<template>
	<div class="reuslts-page centering">
		<div class="banner-container">
			<div class="inner"></div>
		</div>

		<div class="text-container centering">
		<h2>Οδηγίες Χρήσης</h2>
		<div class="divider"></div>
		<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
		<p>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?</p>
		<p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat</p>
		<p>orem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
		</div>

		<div class="books">
			<div class="inner"></div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'SearchResults',
	components: {
	},
	data: () => {
		return {
		}
	},
	computed: {

	},
	methods: {

	},
	mounted() {
	},
	watch: {
		currentApiPage(x, y) {
			// console.log("changed")
		}
	}
}
</script>

<style scoped lang="scss">
	.fadeIn-enter-active {
		opacity: 1;
		transition: all 1s ease;
	}

	.fadeIn-enter {
		opacity: 0;
	}

	.reuslts-page {
		background-image: url('../assets/img/2.jpg');
		background-size: cover;
		background-repeat: no-repeat;
	}

	.banner-container {
		width: 100%;
		height: 20vw;

		.inner {
			background-image: url('../assets/img/photo_search.jpg');
			background-size: cover;
			background-repeat: no-repeat;
			background-position: center;
			height: 100%;
			width: 100%;
		}
	}

	.text-container {
		padding: 5% 10%;
		width: 75%;
		max-width: 1250px;
		align-items: flex-start;

		h2 {
			font-size: calc(14px + (25 - 14) * ((100vw - 300px) / (1600 - 300)));
			font-weight: bold;
		}

		p {
			text-align: justify;
			font-size: calc(14px + (18 - 14) * ((100vw - 300px) / (1600 - 300)));
			line-height: 1.4;
		}
	}

	.books {
		width: 100%;
		height: 20vw;

		.inner {
			background-image: url('../assets/img/photo_books_1.png');
			background-size: contain;
			background-repeat: no-repeat;
			background-position: center bottom;
			background-color: transparent;
			width: 100%;
			padding: 10% 0;
		}
	}

	.divider {
		width: 10%;
		border-bottom: 1px solid #000;
		margin: 5% 0 2.5% 0;
	}

	@media(max-width: 720px) {
	.text-container {
		width: 90%;
	}

}

	@media(max-width: 560px) {
	}
</style>
